import React, { useEffect } from 'react';
import Select from 'react-select';
import { useController, useFormContext } from 'react-hook-form';
import NoSsr from '@common/noSsr';
import { ReactSelectStyles } from '@components/profile/profileOverlay/overlays/ReactSelectStyles';
import { ProfileEducationFormVO } from '@domain/vo/profile/ProfileEducationFormVO';
import { EducationLevel, educationLevelOptions } from '@domain/constant/profile/EducationType';
import { ReactSelectOption } from '@domain/constant/ReactSelectOption';
import classnames from 'classnames/bind';
import styles from '../edu.module.scss';

const cx = classnames.bind(styles);

interface SchoolLevelProps {
  name: string;
}

const SchoolLevel = ({ name }: SchoolLevelProps) => {
  const { setValue, resetField } = useFormContext<ProfileEducationFormVO>();
  const { field, fieldState } = useController({ name });

  useEffect(() => {
    setValue('majorUseYn', field.value?.value !== EducationLevel.HIGHSCHOOL);
  }, [field]);

  const handleOnChange = (option: ReactSelectOption) => {
    field.onChange(option);
    setValue('school', null);
    setValue('educationType', null);
    setValue('startDate', '');
    setValue('endDate', '');
    setValue('majorUseYn', option.value !== EducationLevel.HIGHSCHOOL);
  };

  return (
    <div className={cx('selectArea')}>
      <NoSsr>
        <Select
          {...field}
          onChange={(option: any) => handleOnChange(option)}
          className={cx('select', { error: fieldState.invalid })}
          placeholder={'학교 구분을 선택해주세요.'}
          styles={ReactSelectStyles}
          isSearchable={false}
          options={educationLevelOptions}
        />
      </NoSsr>
      {fieldState.invalid && <div className={cx('errorMessage')}>학교 구분을 선택해주세요.</div>}
    </div>
  );
};

export default SchoolLevel;
